import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Calendar, CalendarModule } from 'primeng/calendar';

@Component({
  standalone: true,
  selector: 'crm-datepicker',
  templateUrl: './datepicker.component.html',
  imports: [CommonModule, CalendarModule, FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatepickerComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('calendar', { static: true }) public readonly calendar: Calendar;

  public _value: Date | Date[];

  public _minDate: Date;
  public _maxDate: Date;

  @Input()
  public set value(date: Date | string) {
    if (date) {
      this._value = new Date(date);
    } else {
      this._value = null;
    }
  }

  @Input()
  public set valueMultiple(dates: Date[] | string[]) {
    if (dates && Array.isArray(dates)) {
      this._value = dates.map((date) => new Date(date));
    } else {
      this._value = null;
    }
  }

  @Input()
  public set minDate(date: Date | string) {
    if (date) {
      this._minDate = new Date(date);
    } else {
      this._minDate = null;
    }
  }

  @Input()
  public set maxDate(date: Date | string) {
    if (date) {
      this._maxDate = new Date(date);
    }
  }

  @Output() public valueChange = new EventEmitter<Date>();
  @Output() public valueMultipleChange = new EventEmitter<Date[]>();

  @Input() public class: string;
  @Input() public disabled: boolean;
  @Input() public modelOptions: any;
  @Input() public showButtonBar = false;
  @Input() public dateFormat: string;
  @Input() public defaultDate: Date = new Date();
  @Input() public monthNavigator: boolean;
  @Input() public yearNavigator: boolean;
  @Input() public yearRange: string;
  @Input() public readonlyInput = true;
  @Input() public placeholder: string;
  @Input() public styleClass: string;
  @Input() public inputStyleClass: string;
  @Input() public panelStyleClass: string;
  @Input() public timeOnly = false;
  @Input() public showTime = false;
  @Input() public view: 'date' | 'month' | 'year' = 'date';
  @Input() public selectionMode: 'single' | 'multiple' | 'range' = 'single';
  @Input() public showClear = false;
  @Input() public appendTo: any;
  @Input() public stepHour = 1;
  @Input() public stepMinute = 1;
  @Input() public stepSecond = 1;

  @Input() public isNotCheckedExternal = false;

  private timer: NodeJS.Timeout;

  public constructor(private readonly renderer2: Renderer2) {}

  public ngOnInit() {
    this.timer = setInterval(() => {
      if (this.isNotCheckedExternal) {
        (this.calendar?.contentViewChild?.nativeElement as HTMLElement)?.querySelectorAll('span')?.forEach((el) => {
          this.renderer2.addClass(el, 'p-datepicker-not-check-external');
        });

        const monthBtn = (this.calendar?.contentViewChild?.nativeElement as HTMLElement)?.querySelector(
          '.p-datepicker-month'
        );
        if (monthBtn) {
          this.renderer2.addClass(monthBtn, 'p-datepicker-not-check-external');
        }

        const yearBtn = (this.calendar?.contentViewChild?.nativeElement as HTMLElement)?.querySelector(
          '.p-datepicker-year'
        );
        if (yearBtn) {
          this.renderer2.addClass(yearBtn, 'p-datepicker-not-check-external');
        }
      }
    }, 300);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    // Для переключения dateFormat внутри p-calendar
    if (changes.view && !changes.view.firstChange) {
      if (this.selectionMode === 'multiple') {
        this._value = (this._value as Date[]).map((_date) => new Date(_date));
      } else {
        this._value = new Date(this._value as any);
      }
    }
  }

  public ngOnDestroy() {
    clearInterval(this.timer);
  }
}
